import { useEffect, useMemo, useState } from "react";
import { Card, Col, Container, Image, Row } from "react-bootstrap";
import { BsBarChartFill, BsCashCoin, BsFillCartCheckFill, BsWallet2 } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

import { useTranslateContext } from '../../contexts/translate.context';
import { usePartnerContext } from '../../contexts/partner.context';

import SearchIcon from '@mui/icons-material/Search';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import { Box, FormControl, FormHelperText, Input, InputAdornment, InputLabel, Tooltip } from '@mui/material';
import Jet from '../../assets/images/Jetski.svg';
import Lancha from '../../assets/images/Lancha.svg';
import { VesselOwner } from '../../components/sub-render.component';
import TableContainer from "../../components/table-container.component";
import { useAlertMessageContext } from "../../contexts/alert-message.context";
import lclService from "../../services/lcl.service";
import { dateToString, toFloat, toInt, toStringFloat } from "../../utilities/auxiliary-functions";
import { VESSEL_JETSKI } from "../../utilities/constants";
import { floatMask } from "../../utilities/masks";
import { AlertMessageEnum, getManufacturerName, getVessel } from "../../utilities/types";
import DashboardHeader from "../headers/dashboard.header";
import styles from './SharingManagementDashboard.module.scss';
import IconImageLightbox from '../../components/icon-image-lightbox/IconImageLightbox';
import { TFilter } from '../../types/FilterType';
import { isEmpty } from '../../utilities/validators';
import authService from "../../services/auth.service";
import Loader from "../../components/loader/loader";
import { StripBox, StripCard } from "./components/StripBox";

interface ISharingManagementDashboardProps {
    
}

export const SharingManagementDashboard: React.FC<ISharingManagementDashboardProps> = () => {

    const { display } = useTranslateContext();
    let { partner } = usePartnerContext();

    const alertContext = useAlertMessageContext();
    const navigator = useNavigate();
  
    const title = "Gestão Compartilhamento";
    const description = "";

    let reloadPage: boolean = false;
    const [ loading, setLoading ] = useState(false);

    const [ countLancha, setCountLancha ]  = useState(0);
    const [ countJetski, setCountJetski ]  = useState(0);
    const [ quotasAvailable, setQuotasAvailable ]  = useState(0);
    const [ quotasQuantity, setQuotasQuantity ]  = useState(0);
    const [ sumPredicted, setSumPredicted ] = useState(0);
    const [ sumRealized, setSumRealized ] = useState(0);

    const [ textSearch, setTextSearch ] = useState('');
    const [ originalRecords, setOriginalRecords ] = useState([]);
    const [ records, setRecords ] = useState([]);

    const columnsRecord = useMemo(() => [{
        Header: 'Nome | ID',
        accessor: "identifyKey",
        Cell: (row: any) => (
            <div className="d-flex flex-column align-items-center justify-content-center">
                <div className="white-space mt-2">{getName(row)}</div>
                <div className="white-space mt-1">{row.value}</div>
            </div>
        )
    },{
        Header: 'TIPO | COR',
        accessor: 'color',
        Cell: (row: any) => (
            getVessel(getVesselType(row)).id === 34 ? (
                <div className="d-flex flex-column align-items-center justify-content-center mb-2">
                    <div className="mt-2 d-flex justify-content-center mb-2">
                        <Image src={Lancha} className="jet" style={{height: 32}}/>
                        <small className="ms-2">{`${getVesselSize(row)}'`}</small>
                    </div>
                <span className={styles.vesselColor} style={{backgroundColor: `${row.value}`}}></span>
                </div>
            ):(
                <div className="d-flex flex-column align-items-center justify-content-center mb-2">
                    <div className="d-flex justify-content-center mb-2">
                        <Image src={Jet} className="jet mt-3" style={{height: 32}}/>
                        <small className="ms-1 mt-3">{`10'`}</small>
                    </div>
                    <span className={styles.vesselColor} style={{backgroundColor: `${row.value}`}}></span>
                </div>
            )
        )
    },{
        Header: display.label.enrollment,
        accessor: "enrollment",
        Cell: (row: any) => (<div className="white-space mt-4">{row.value}</div>)
    },{
        Header: display.label.drawer,
        //accessor: "bookcase",
        Cell: (props: any) => {
            const bookcase = props.row.original.bookcase;

            if (bookcase?.name) {
                return (
                    <Tooltip className="isClickable d-flex text-center justify-content-center w-100 mt-4" title={` ${bookcase?.name ? bookcase?.name | bookcase?.shelves[0]?.name | bookcase?.shelves[0]?.drawers[0]?.name : ''}`}>
                        <WarehouseIcon color="inherit" className="mt-1" />
                    </Tooltip>
                );
            }
        }

    },{
        Header: 'MAR | MOD',
        accessor: "manufacturer",
        Cell: (row: any) => (
            <div className="d-flex flex-column align-items-center justify-content-center">
                <div className="white-space mt-2">{getManufacturerName(row.value)}</div>
                <div className="white-space mt-1">{getModel(row)}</div>
            </div>
        )
    },{
        Header: 'Propriedade',
        Cell: (props: any) => (
            <div className="mt-4">
                <VesselOwner values={props} />
            </div>
        )
    },{
        Header: 'Cotas',
        accessor: "quotasAvailable",
        Cell: (props: any) => {
            const vessel = props.row.original;

            return (
                <div className="d-flex flex-column align-items-center justify-content-center">
                    <div className="white-space mt-1"><BsFillCartCheckFill className="me-2" size={16} />{vessel.quotasQuantity}</div>
                    <div className="white-space mt-2"><BsWallet2 className="me-2" size={16} />{vessel.quotasAvailable}</div>
                </div>
            )
        }
    },{
        Header: 'Foto',
        accessor: "image",
        Cell: (row: any) => {
            return (
                <div className="white-space table-actions mt-4">
                    <IconImageLightbox alt='Imagem da embarcação' src={row.value} />
                </div>
            );
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }], []); // columnsRecord

    const getName = (column: any) => {
        if (column?.data?.length) {
            const name =  column.data.find((movement: any) => movement?.identifyKey === column.row.original?.identifyKey)
            if (name)
                return name.name
        }
        return '-'
    }

    const getVesselType = (column: any) => {
        if (column?.data?.length) {
            const type =  column.data.find((movement: any) => movement?.identifyKey === column.row.original?.identifyKey)
            if (type)
                return type.typeVessel
        }
        return '-'
    }

    const getVesselSize = (column: any) => {
        if (column?.data?.length) {
            const type =  column.data.find((movement: any) => movement?.identifyKey === column.row.original?.identifyKey)
            if (type)
                return type.vesselSize
        }
        return '-'
    }

    const getModel = (column: any) => {
        if (column?.data?.length) {
            const model =  column.data.find((movement: any) => movement?.identifyKey === column.row.original?.identifyKey)
            if (model)
                return model.model
        }
        return '-'
    }

    async function searchFilter() {
        /* Sempre incluir o partner na pesquisa */
        if (!isEmpty(partner)) {
            try {
                const resultVessels = await lclService.vesselList(partner.id);
                const vessels = resultVessels.rows;

                let countJetski = 0;
                let countLancha = 0;

                let quotasAvailable = 0;
                let quotasQuantity = 0;

                let sumPredicted = 0;
                let sumRealized = 0;
                vessels.forEach((vessel: any) => {
                    if (toInt(vessel.typeVessel) === VESSEL_JETSKI)
                        countJetski += 1;
                    else
                        countLancha += 1;

                    quotasAvailable += toInt(vessel.quotasAvailable);
                    quotasQuantity +=  toInt(vessel.quotasQuantity);

                    let quota = toFloat(vessel.quotasAmount) / (toInt(vessel.quotasAvailable) + toInt(vessel.quotasQuantity));
                    sumPredicted += toFloat(vessel.quotasAmount);
                    sumRealized += (toFloat(quota) * toInt(vessel.quotasQuantity));
                });
                setCountJetski(countJetski);
                setCountLancha(countLancha);
                setQuotasAvailable(quotasAvailable);
                setQuotasQuantity(quotasQuantity);     
                setSumPredicted(sumPredicted);
                setSumRealized(sumRealized);           

                setRecords(vessels);
                setOriginalRecords(vessels);
            } catch(error: any) {
                await alertContext.show(AlertMessageEnum.FAIL, 'Gestão Compartilhamento', error);
            }
        } else {
            await alertContext.show(AlertMessageEnum.FAIL, 'Gestão Compartilhamento', 'Não foi definido uma Marina para exibir o cadastro !');
            navigator(`/portal`);
        }
    } // searchFilter

    const filterVessels = (key?: string, value?: string) => {

        const filteredVessels: any = []
        records.filter((record: any) => {
          if (
            record.identifyKey
              .toLocaleLowerCase()
              .includes(textSearch.toLocaleLowerCase()) ||
            record.name
              .toLocaleLowerCase()
              .includes(textSearch.toLocaleLowerCase()) ||
            record.enrollment
              .toLocaleLowerCase()
              .includes(textSearch.toLocaleLowerCase())
          )
          filteredVessels.push(record)
          return record
        })
        setRecords(filteredVessels)
      return ''
    }

    useEffect(() => {
        if (textSearch.length >= 3) {
            filterVessels()
        } else if (textSearch.length < 3) {
          setRecords(originalRecords)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [textSearch]);

    useEffect(() => {
        if (isEmpty(partner))
            // eslint-disable-next-line react-hooks/exhaustive-deps
            partner = authService.currentPartner();
        if (!reloadPage) {
            reloadPage = true;
    
            setLoading(true)
            setTimeout(() => {
                searchFilter().finally(() => {
                setLoading(false);
              });
            }, 500)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function viewDashboard() {

        return (
            <Container fluid className="page-body dashboards">
                <StripBox>
                    <StripCard className="blue" label="Embarcações" datas={[{ image: Lancha, value: String(countLancha || 0) }, { image: Jet, value: String(countJetski || 0) }]} />
                    <StripCard className="orange" label="Total Previsto" image={<BsBarChartFill size={38} />} value={`R$ ${toStringFloat(sumPredicted)}`} />
                    <StripCard className="cyan" label="Total Realizado" image={<BsCashCoin size={38} />} value={`R$ ${toStringFloat(sumRealized)}`} />
                    <StripCard className="green" label="Cotas Vendidas" image={<BsFillCartCheckFill size={38} />} value={`${quotasQuantity}`} />
                    <StripCard className="reddish_pink" label="Cotas Disponíveis" image={<BsWallet2 size={38} />} value={`${quotasAvailable}`} />
                </StripBox>
                <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                    <Card className={`flex-grow-1 ${styles.vesselList}`}>
                        <Card.Header>
                            <Card.Title>Embarcações Compartilhadas</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <FormControl variant="standard">
                                <InputLabel className={styles.label} htmlFor="standard-adornment-amount">Pesquisar</InputLabel>
                                <Input id="standard-adornment-amount"
                                    value={textSearch}
                                    onChange={(e) => setTextSearch(e.target.value)}
                                    endAdornment = {
                                        <InputAdornment position="end">
                                            <SearchIcon className='isClickable' />
                                        </InputAdornment>
                                    }
                                />
                                <FormHelperText id="component-helper-text">
                                    ID, Nome ou Registro da Embarcação
                                </FormHelperText>
                            </FormControl>
                            <TableContainer className={'table-list-record'} columns={columnsRecord} data={records} viewPagination={records.length > 10}/>
                        </Card.Body>
                    </Card>
                </Box>
            </Container>
        );
    }

    return (
        <div className="dashboard">
            <DashboardHeader title={title} description={description} />
            {loading ? <Loader /> : viewDashboard()}
        </div>
    );
}

export default SharingManagementDashboard;
